var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCommentIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 29 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-6599.61,-1398.24)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.503937,0,0,0.571731,5702.11,467.537)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "New-Message",
    serifId: "New Message",
    transform: "matrix(1.30379,4.24947e-32,1.60705e-32,1.14919,1657.05,1194.57)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.8,377.8C105.2,377.8 95.8,385.5 95.8,394.9C95.8,400.6 99.1,405.5 104.4,408.6C103.7,412.1 99.9,415.8 99.9,415.8C99.9,415.8 106.4,416.6 111.2,411.8C111.2,411.8 116.8,412 118.8,411.9C130.4,411.6 137.8,404.2 137.8,394.8C137.8,385.4 128.4,377.8 116.8,377.8ZM118.8,409.9C117,409.9 110.4,409.8 110.3,409.7C109.5,411 105.4,414 103.4,413.8C104.8,412.3 106.5,408.2 106.4,407.4C105.7,407 105.1,406.6 104.4,406.2C100.3,403.4 97.7,399.3 97.7,394.7C97.7,386.4 106.2,379.6 116.7,379.6C127.2,379.6 135.7,386.4 135.7,394.7C135.7,403 129.3,409.9 118.8,409.9Z",
    style: {
      fill: "rgb(109,109,109)",
      fillRule: "nonzero",
      stroke: "rgb(109,109,109)",
      strokeWidth: "1.52px"
    }
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentIcon);
export default __webpack_public_path__ + "static/media/comment_icon.4f67bb026008a9ddf744db0a2f493ed2.svg";
export { ForwardRef as ReactComponent };